import { render, staticRenderFns } from "./DepaBird.vue?vue&type=template&id=68c4afa3&scoped=true"
import script from "./DepaBird.vue?vue&type=script&lang=js"
export * from "./DepaBird.vue?vue&type=script&lang=js"
import style0 from "./DepaBird.vue?vue&type=style&index=0&id=68c4afa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4afa3",
  null
  
)

export default component.exports